<div class="ca-page">

  <div class="ca-header">
    <a routerLink="/contractors" class="ca-back-link">
      <mat-icon>arrow_back</mat-icon> Contractors
    </a>
    <h1 class="ca-title">Add Contractor</h1>
  </div>

  <div class="ca-card">
    <form (ngSubmit)="saveContractor()" #contractorForm="ngForm">

      <!-- Photo section -->
      <div class="ca-photo-section">
        <div class="ca-avatar-wrap">
          <img *ngIf="imagePreview" [src]="imagePreview" class="ca-avatar-img" alt="Profile photo">
          <div class="ca-avatar-initials" *ngIf="!imagePreview">{{ initials(newContractor.name) }}</div>
        </div>
        <div class="ca-photo-actions">
          <div class="ca-preview-name">{{ newContractor.name || 'New Contractor' }}</div>
          <div class="ca-preview-title">{{ newContractor.jobTitle || 'No title set' }}</div>
          <div class="ca-photo-btns">
            <label class="ca-upload-btn" matRipple>
              <mat-icon>upload</mat-icon>
              {{ imagePreview ? 'Change Photo' : 'Upload Photo' }}
              <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden>
            </label>
            <button mat-icon-button type="button" (click)="clearPhoto()"
                    *ngIf="imagePreview" matTooltip="Remove photo" class="ca-clear-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <mat-divider style="margin: 16px 0 20px;"></mat-divider>

      <div class="ca-grid">

        <mat-form-field appearance="outline" class="ca-field-wide">
          <mat-label>Full Name</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input matInput [(ngModel)]="newContractor.name" name="name" required placeholder="First Last">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Job Title / Trade</mat-label>
          <mat-icon matPrefix>work</mat-icon>
          <input matInput [(ngModel)]="newContractor.jobTitle" name="jobTitle" required placeholder="e.g. Electrician">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Cell Phone</mat-label>
          <mat-icon matPrefix>phone</mat-icon>
          <input matInput [(ngModel)]="newContractor.cellPhone" name="cellPhone" type="tel" placeholder="(555) 000-0000">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <mat-icon matPrefix>email</mat-icon>
          <input matInput [(ngModel)]="newContractor.email" name="email" type="email" placeholder="name@example.com">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Hourly Wage</mat-label>
          <mat-icon matPrefix>schedule</mat-icon>
          <span matSuffix>/hr</span>
          <input matInput [(ngModel)]="newContractor.hourlyWage" name="hourlyWage" type="number" min="0" placeholder="0.00">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Salary (annual)</mat-label>
          <mat-icon matPrefix>payments</mat-icon>
          <span matSuffix>/yr</span>
          <input matInput [(ngModel)]="newContractor.salary" name="salary" type="number" min="0" placeholder="0">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Age</mat-label>
          <input matInput [(ngModel)]="newContractor.age" name="age" type="number" min="18" placeholder="e.g. 35">
        </mat-form-field>

      </div>

      <div class="ca-actions">
        <button mat-stroked-button type="button" routerLink="/contractors">Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="contractorForm.invalid || isSaving">
          <mat-icon>save</mat-icon>
          {{ isSaving ? 'Saving...' : 'Save Contractor' }}
        </button>
      </div>

    </form>
  </div>

</div>
